import React, { Component } from 'react'
import './Loading.scss';

class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
    }
    render() {
        return (
            <div className="loading">
                <div className="sprint">
                    <div className="splash-container">
                        <div className="loader mx-auto" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Loading;